package com.essntl.uikit.components.button.custom

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import com.essntl.uikit.components.button.EsButton
import com.essntl.uikit.components.button.EsButtonColors
import com.essntl.uikit.components.button.EsButtonSize
import com.essntl.uikit.theme.EsColorScheme
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsListDialogButton(
    onClick: () -> Unit,
    text: String,
    prefixIconRes: String? = null,
    suffixIconRes: String? = null,
    prefixIconUrl: String? = null,
    suffixIconUrl: String? = null,
    enabled: Boolean = true,
    loading: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    modifier: Modifier = Modifier,
) {
    val essntlColorScheme = MaterialTheme.esColorScheme

    EsButton(
        onClick = onClick,
        size = EsButtonSize.Small,
        colors = getListDialogButtonColors(essntlColorScheme),
        text = text,
        prefixIconRes = prefixIconRes,
        suffixIconRes = suffixIconRes,
        prefixIconUrl = prefixIconUrl,
        suffixIconUrl = suffixIconUrl,
        enabled = enabled,
        loading = loading,
        interactionSource = interactionSource,
        modifier = modifier,
    )
}

internal fun getListDialogButtonColors(esColorScheme: EsColorScheme) = EsButtonColors(
    containerColor = esColorScheme.bgPrimary,
    disabledContainerColor = esColorScheme.bgPrimary,
    pressedContainerColor = esColorScheme.ghostPressed.copy(alpha = .8f),
    hoveredContainerColor = esColorScheme.ghostPressed,
    focusedContainerColor = esColorScheme.bgPrimary,
    textColor = esColorScheme.textPrimary,
    disabledTextColor = esColorScheme.textDisabled,
    iconColor = esColorScheme.iconPrimary,
    disabledIconColor = esColorScheme.iconDisabled,
    borderFocusColor = esColorScheme.bgPrimary,
)